import React from "react";
import { ReactMic } from "react-mic";
import { v4 as uuidv4 } from 'uuid';
import { msToHMS, playSound } from "../../../utils/useful";
import RecordCanvas from "../../RecordCanvas";
// import HttpServices from "../../../utils/Http.services";

class MessengerRecording extends React.Component {
    state = {
        time: 0,
        isRecord: false,
        pauseRecord: false,
        recordInProgress: false
    }

    componentDidMount() {

    }

    startRecording = () => {

        console.log("startRecording")
        // setTimeout(() => {
        //     this.setState({ showRecording: true }, () => {
        //         setTimeout(() => {
        this.setState({ isRecord: true, recordInProgress: true, pauseRecord: false, time: 0 }, () => {
            this.setTimer()
        })

        // this.setState({ time: 0 }, () => {
        // this.setTimer()
        // })

        //         }, 500);
        //     })
        // }, 50);
    }

    setTimer() {

        this.timer = setInterval(() => {
            this.setState({ time: this.state.time + 1 })
        }, 1000);

    }

    // onStop = () => {
    //     console.log("onStop")
    // }


    stopRecording = () => {
        // return
        // this.recordVoice()
        clearInterval(this.timer)
        this.setState({ isRecord: false, }, () => {
            this.setState({ recordInProgress: false })
        })
        // this.onStop()
        this.setState({ pauseRecord: false })
    }

    recordVoice = () => {

        setTimeout(() => {
            this.element.startWave()
        }, 400);

        this.startRecording()

    }


    pauseRecord = () => {
        if (this.state.pauseRecord) {
            this.setTimer()
        } else {
            clearInterval(this.timer)
        }
        this.setState({ pauseRecord: !this.state.pauseRecord })
    }


    cancelVoice = () => {
        this.setState({ cancelVoice: true }, () => {
            // this.onStop()
            setTimeout(() => {
                this.setState({ cancelVoice: false })
            }, 200)
        })
    }


    // sendVoice=()=>{

    // }

    sendVoice = () => {

        this.setState({ recordInProgress: false })
        clearInterval(this.timer)

        console.log("sendVoice")
    }



    onStop = async (recordedBlob) => {

        console.log("onStop")

        console.log("this is blob rec", recordedBlob, this.state.recordInProgress)

        if (!this.state.recordInProgress && this.state.isRecord) {
            // this.setState({ recordInProgress: false })

            let metadata = {
                type: 'audio/mp3',
            };


            // if (this.state.cancelVoice) {
            //     return
            // }
            // else {
            if (recordedBlob) {
                console.log('recordedBlob', recordedBlob)
                const voiceMessage = new File([recordedBlob.blob], `${uuidv4()}.mp3`, metadata);
                // const voiceMessage = new File([convertedAudio], `${uuidv4()}.ogg`, metadata);

                // console.table(this.props.messengerId, this.props.type)

                // let rawmessage = {
                //     tempFile: this.props.tempFile
                // }

                this.props.sendFile([voiceMessage], 'voice')

                this.setState({ isRecord: false })


                // this.props.createMessage(rawmessage, (message) => {

                //     this.props.actions.addMessages(this.props.messengerId, [message])
                //     HttpServices.addUploadQueque(voiceMessage, { messenger: this.props.messengerId, type: this.props.type }, message.tempId)

                //     this.scrollToBottom(true)

                // })
                // }

            }
        }




    }


    onData = (e) => {
        console.log(e)
        console.log("this is on data")
    }


    render() {
        return (
            <div className=" h-100 w-100" style={{ position: this.state.isRecord ? "absolute" : "", zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center", background: this.state.isRecord ? "#fff" : "transparent", left: this.state.isRecord ? 0 : "" }}>
                {this.state.isRecord && (

                    <>
                        <div className="flex-1 flexc px-2 position-relative">
                            <div className="flexc mx-1">

                                <div className="" style={{ backgroundColor: this.state.pauseRecord ? '#aaa' : '#ee5050', width: 12, height: 12, borderRadius: 10 }}>

                                </div>

                                <p className="mx-1 ">{msToHMS(this.state.time)}</p>
                            </div>
                            {/* <div className="position-absolute w-100 left-0 flexcc ">
                                <p onClick={() => this.cancelVoice()} style={{ color: "red" }} className="mx-5">Cancel</p>
                            </div> */}
                        </div>
                        {/* <p>{this.state.recordInProgress}</p> */}

                    </>

                )}


                {this.state.isRecord ? (
                    <div style={{ position: "relative", marginRight: -15, }}>

                        <div style={{ width: "200px", transform: 'translate(70px,70px)', right: 0, bottom: 0, height: "200px", position: "absolute", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <RecordCanvas control={this.state.isRecord} ref={el => this.element = el} pauseRecord={this.state.pauseRecord} colors={this.props.colors} />
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>


                            <button onClick={() => this.stopRecording()} style={{ marginRight: 10, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3 }}>
                                <img style={{ width: 30, height: 30 }} src="/assets/icons/messenger/trash-red.svg" />
                            </button>


                            <button onClick={() => this.pauseRecord()} style={{ borderRadius: 50, marginRight: 10, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3 }}>
                                {!this.state.pauseRecord ? (
                                    <img style={{ width: 40, height: 40 }} src="/assets/icons/messenger/pause.circle.fill.svg" />
                                ) : (
                                    <img className="" style={{ width: 40, height: 40 }} src="/assets/icons/messenger/play.circle.fill.svg" />
                                )}
                            </button>



                            <button onClick={() => this.sendVoice()} draggable={false} className="px-1 flexcc recordButton pulse" style={{ transition: '0.3s all', position: 'relative', borderRadius: 100, width: 60, height: 60 }}>
                                <img className="" draggable={false} src={'/assets/icons/messenger/send-black.svg'} style={{ transition: '0.3s all' }} height={40} />
                            </button>

                        </div>

                    </div>
                ) : (
                    <button style={{}} onClick={() => this.recordVoice()} className="px-1 flexcc">
                        <img src={'/assets/icons/messenger/mic.svg'} height={30} />
                    </button>
                )}



                <ReactMic
                    // pause={this.state.pauseRecord}
                    record={this.state.recordInProgress}
                    className="d-none"
                    mimeType="audio/mp3"
                    // mimeType="audio/ogg"
                    // mimeType="audio/wav"
                    // onStop={(e) => this.onStop(e)}
                    // onData={(e) => this.onData(e)}
                    onStop={this.onStop}
                    onData={this.onData}
                    strokeColor="#000000"
                    visualSetting="sinewave"
                    echoCancellation={true}
                    // backgroundColor="#FF4081"
                    autoGainControl={true}
                    noiseSuppression={true}
                // bitRate={256000}          // defaults -> 128000 (128kbps).  React-Mic-Gold only.
                // sampleRate={96000}        // defaults -> 44100 (44.1 kHz).  It accepts values only in range: 22050 to 96000 (available in React-Mic-Gold)
                // timeSlice={3000}  
                />

            </div>
        )
    }

}


export default MessengerRecording
